import { Container, Typography } from 'radiance-ui';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import styled from '@emotion/styled';

export const ButtonContainer = styled(Container)`
  margin-top: ${SPACER.xlarge};
  margin-right: -${SPACER.large};
  margin-left: -${SPACER.large};
  padding: ${SPACER.large} ${SPACER.large};
  width: 100vw;

  & + & {
    margin-top: ${SPACER.small};
  }

  ${MEDIA_QUERIES.mdUp} {
    margin-top: ${SPACER.x2large};
    padding: ${SPACER.xlarge} ${SPACER.large};
    max-width: 42rem;

    & + & {
      margin-top: ${SPACER.large};
    }
  }
`;

export const Caption = styled(Typography.Caption)`
  margin-bottom: ${SPACER.large};
  width: 100%;
`;

export const MedicalRecordRequestLink = styled.a`
  margin: ${SPACER.x2large} auto;
  color: ${({ theme }) => theme.COLORS.primary};
  text-align: center;

  ${MEDIA_QUERIES.mdUp} {
    margin-top: ${SPACER.x4large};
  }
`;
